import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import LiquidCheckbox from '@src/components/LiquidCheckbox'
import useTubeValidation from '../useTubeValidation'
import useFormikHelper from '../useFormikHelper'
import { useCurrentUser } from '@src/utils/useCurrentUser'
import useTubeTotalValidation from '../useTubeTotalValidation'
import { handleOligoValidationAndPricing } from '../utils'
import {
  checkForRedesignedBiTubeProduct,
  useProductFromQueryParam,
  useProductInput,
} from '../ProductsConfiguration'
import {
  useBiTubePriceCallMutation,
  useSessionFieldsMutation,
  useTubePriceCallMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import { makeStyles } from '@material-ui/core/styles'
import { getSessionDataFromFormikData } from '../SessionDataUtil'
import { useRouter } from '@src/routes'
import { ActiveLinkType } from '../../BiTube/enum'

const useStyles = makeStyles((theme) => ({
  checkboxContainer: {
    flexDirection: 'row-reverse',
  },
  checkboxRoot: {
    alignItems: 'center',
    verticalAlign: 'inherit',
  },
  label: {
    fontSize: theme.typography.pxToRem(14),
    flexShrink: 0,
    width: '100%',
  },
  itemLevelCheckbox: {
    justifyContent: 'flex-end',
  },
}))
interface CsrOverrideProps {
  allOligos?: boolean
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>
  loading?: boolean
}

const CsrOverride: React.FC<CsrOverrideProps> = ({
  allOligos = false,
  setLoading,
  loading = false,
}) => {
  const formik = useFormikHelper()
  const classes = useStyles()
  const { validationAPI } = useTubeValidation()
  const { isCustomProductCSR } = useCurrentUser()
  const product = useProductFromQueryParam()
  const productDetails = useProductInput()
  const [checked, setChecked] = useState(
    !formik.allValues.oligoList.find((oligo) => !oligo.isOverridden)
  )

  const isBiTubeProduct = checkForRedesignedBiTubeProduct(product)

  const { totalValidationAPI } = useTubeTotalValidation()
  const [tubePriceCall] = useTubePriceCallMutation()
  const [biTubePriceCall] = useBiTubePriceCallMutation()
  const priceCall = isBiTubeProduct ? biTubePriceCall : tubePriceCall
  const [sessionFields] = useSessionFieldsMutation()
  const sessionData = getSessionDataFromFormikData(
    product,
    formik.allValues.oligoList
  )
  const productInput = useProductInput()
  const router = useRouter()
  const isConfirmOrderPage =
    router.query.activeLink === ActiveLinkType.ConfirmOrder

  const onOverrideValidationChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newSesssionData = sessionData.map((oligo, index) => ({
      ...oligo,
      isOverridden: e.target.checked,
      oligoId: index,
    }))
    isConfirmOrderPage &&
      sessionFields({
        variables: {
          input: newSesssionData,
          productInput,
        },
      })
    if (allOligos) {
      setLoading && setLoading(true)
      setChecked(e.target.checked)
      //set value for all oligos
      const newList = formik.allValues.oligoList.map((oligo, index) => ({
        ...oligo,
        isOverridden: e.target.checked,
        oligoId: index,
      }))

      handleOligoValidationAndPricing(
        product,
        newList,
        formik,
        productDetails,
        totalValidationAPI,
        priceCall,
        false
      )
      setLoading && setLoading(false)
    } else {
      formik.touchRequiredFields()
      formik.setOligoFieldValue('isOverridden', e.target.checked, false)
      await validationAPI(
        {
          ...formik.validationFields,
          isOverridden: e.target.checked,
        },
        true
      )
    }
  }

  return (
    <>
      {isCustomProductCSR && (
        <Grid item xs={12}>
          <Grid
            container
            spacing={3}
            className={
              allOligos ? classes.checkboxContainer : classes.itemLevelCheckbox
            }
          >
            <Grid item>
              <LiquidCheckbox
                formControlClasses={
                  allOligos
                    ? { root: classes.checkboxRoot, label: classes.label }
                    : {}
                }
                checked={
                  allOligos
                    ? checked
                    : !!formik.selectedOligoValues.isOverridden
                }
                disabled={loading}
                onChange={onOverrideValidationChange}
                label={
                  <FormattedMessage
                    id="CSR_OVERRIDE_VALIDATION"
                    defaultMessage="CSR Override Validation"
                  />
                }
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default CsrOverride
